<template>
	<div>
		<el-dialog :visible.sync="showexportwin" :title="exportwin_lang.seltemp" width="500px"
		 :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" 
		 :show-close="false" :destroy-on-close="true">
			<div class="exportwin" style="height:200px" align="center">
				<table class="htmltable">
					<tr>
						<td colspan="2">
							<el-select size="mini" v-model="e_name" :placeholder="exportwin_lang.seltemp" @change="changeexportmode" style="width:200px">
								<el-option v-for="item in exportmode" :key="item.p_id" :label="item.e_name" :value="item.p_id"></el-option>
							</el-select>
						</td>
					</tr>
					<tr style="height:180px;text-align:center;">
						<td style="vertical-align:bottom;"><el-button type="success" size="mini" @click="SureExport">{{suretext}}</el-button></td> <!-- {{$lang.label.public.sure}} -->
						<td style="vertical-align:bottom;"><el-button size="mini" @click="showexportwin = false">{{canceltext}}</el-button></td> <!-- {{$lang.label.public.cancel}} -->
					</tr>
				</table>
			</div>
		</el-dialog>
	</el-button>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			showsuccesswin_export: false, //弹窗显示,
			showexportwin:false,
			selectedmodeindex: 0,
			e_name: '',
			exportmode: [
				{
					p_id: '',
					e_name: ''
				}
			],
			p_id:'',
			batch: '',
			pageparam: {},
			handtype: '',
			searchinfo: '',
			e_exporttype:'',
			exportwin_lang:{},
			suretext:'',
			canceltext:'',
			searchItem:''
		};
	},
	mounted() {
		
	},
	methods: {
		init(param){
			var that = this;
			that.searchItem='';
			if(param.batch!=undefined)
				that.batch=param.batch;
			else
				that.batch='';
				
			that.searchinfo = param.searchinfo;
			that.pageparam=param.pageparam;
			that.handtype=param.handtype; //1-自定义导出 0-按指定口岸的模板导出 2-交易账单 3-仓库管理导出，包括入库、出库、库存 列表
			if(param.searchItem!=undefined)
				that.searchItem=param.searchItem;
			//获取导出模板
			var that=this;
			this.$public.GetLanguageByMode('exportwin',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.suretext=that.$lang.label.public.sure;
					that.canceltext=that.$lang.label.public.cancel;
					that.exportwin_lang=that.$lang.label.exportwin;
				}
				that.GetExportTemplate();
			});
		},
		GetExportTemplate(){
			var that=this;
			//console.log('导出',encodeURIComponent(JSON.stringify(this._data)));
			this.$tool.loading(this.exportwin_lang.gettemp);
			this.$apipost.get.GetExportTemplate({paraminfo:this._data}).then(res => {
				//debugger
				//console.log('导出',res);
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.batch=res.batch;
					that.exportmode=res.list;
					that.p_id=that.exportmode[0].p_id;
					that.e_name=that.exportmode[0].e_name;
					that.e_exporttype=that.exportmode[0].e_exporttype;
					if(that.exportmode.length>1){
						that.showexportwin=true;
					}else{
						that.OrderExport_Batch();
					}
				}else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		OrderExport_Batch(){
			var that=this;
			this.$tool.loading(this.exportwin_lang.createtemp,'exportwin');
			this.$apipost.get.OrderExport_Batch({paraminfo:this._data}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					this.$tool.downfile(that,res.filename,that.batch);
					that.showexportwin=false;
				}else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		//选择导出模板
		changeexportmode(val){
			var index=0;
			var list=this.exportmode;
			for(var i=0;i<list.length;i++){
				if(list[i].p_id==val){
					index=i;
					break;
				}
			}
			this.selectedmodeindex = index;
			this.p_id=this.exportmode[index].p_id;
			this.e_name=this.exportmode[index].e_name;
			this.e_exporttype=this.exportmode[index].e_exporttype;
		},
		//确认导出
		SureExport(){
			var that=this;
			if(that.p_id==''||that.p_id==undefined){
				this.$tool.message(this.exportwin_lang.unselecttemp,0);
				return false;
			}
			if(that.batch==''&&that.searchItem==''){
				this.$tool.message(this.exportwin_lang.nodata,0);
				return false;
			}
			that.OrderExport_Batch();
		}
	},
}
</script>

<style>
</style>
